import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import {
  CheckCircleIcon,
  XMarkIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";

const LogoutSessionsSlideOver = ({ show, setShowSlide }) => {
  const [open, setOpen] = useState(true);
  const handleClose = () => {
    setShowSlide(!show);
  };

  return (
    <Transition.Root show={show} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full px-[15px] py-5 md:p-0">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-[478px]">
                  <div className="flex h-full flex-col bg-white py-5 md:py-10 px-4 md:px-8 shadow-xl rounded-md md:rounded-0">
                    <div className="">
                      <div className="flex items-center justify-between border-b border-solid border-[#CCD0D4] mb-[14px] md:mb-5 pb-[14px] md:pb-[30px]">
                        <Dialog.Title className="text-xl md:text-2xl font-bold leading-[160%] text-[#04091E]">
                          Log Out of All Sessions
                        </Dialog.Title>
                        <XMarkIcon className="w-6 h-6 text-black cursor-pointer" onClick={() => handleClose()} />
                      </div>
                    </div>
                    <div className="relative">
                      <p className="text-sm md:text-base leading-[160%] text-[#485868] mb-[30px]">
                      This will log you out of all sessions, including this one. Are you sure?
                      </p>
                    </div>
                    <div className="grid grid-cols-2 gap-5">
                      <button
                        type="button"
                        className="rounded-[10px] border border-solid border-[#EF2121] text-sm md:text-base font-black uppercase text-[#EF2121] flex justify-center items-center gap-[6px] w-full h-10 md:h-[58px]"
                        onClick={() => handleClose()}
                      >
                        <XCircleIcon className="w-6 h-6 text-[#EF2121]" />
                        CANCEL
                      </button>
                      <button
                        type="button"
                        className="rounded-[10px] bg-[#16CA7C] text-sm md:text-base font-black uppercase text-white px-3 flex justify-center items-center gap-[6px] w-full mb-4 h-10 md:h-[58px]"
                      >
                        <CheckCircleIcon className="w-6 h-6 text-white" />
                        YES
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default LogoutSessionsSlideOver;
